import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogContent,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogOverlay,
    Button,
    HStack, Spacer,
} from '@chakra-ui/react';
import React from 'react';

export function ConfirmationDialog({
    title,
    children,
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    isOpen,
    onCancel,
    onConfirm,
    allowCancel = true,
    isLoading,
    isCentered,
    trapFocus = true,
}: {
    children: React.ReactNode;
    title: string;
    isOpen: boolean;
    onCancel: () => void;
    onConfirm: () => void;
    confirmText?: string;
    cancelText?: string;
    allowCancel?: boolean;
    isLoading?: boolean;
    isCentered?: boolean;
    trapFocus?: boolean;
}) {
    const cancelRef = React.useRef<HTMLButtonElement | null>(null);

    return (
        <AlertDialog
            isOpen={isOpen}
            onClose={allowCancel ? onCancel : () => {}}
            leastDestructiveRef={cancelRef}
            motionPreset="slideInBottom"
            isCentered={isCentered}
            trapFocus={trapFocus}
        >
            <AlertDialogOverlay>
                <AlertDialogContent>
                    <AlertDialogHeader fontSize="lg" fontWeight="bold">
                        {title}
                    </AlertDialogHeader>
                    <AlertDialogBody>
                        {children}
                    </AlertDialogBody>
                    <AlertDialogFooter pt={6}>
                        <HStack w="full">
                            {
                                allowCancel && (
                                    <Button
                                        variant="ghost"
                                        ref={cancelRef}
                                        colorScheme="muted"
                                        size="md"
                                        onClick={onCancel}
                                    >
                                        { cancelText}
                                    </Button>
                                )
                            }
                            <Spacer />
                            <Button
                                variant="solid"
                                colorScheme="secondary"
                                onClick={onConfirm}
                                size="md"
                                ml={3}
                                isLoading={isLoading}
                            >
                                {confirmText}
                            </Button>
                        </HStack>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialogOverlay>
        </AlertDialog>
    );
}
